module.exports = {
  "dpmerchant":[
    {
      "methodName": "menuTitle",
      "description": "点评管家-设置下拉选框title",
      "contact": ["hardy.xu", "hardy.xu"]
    },
    {
      "methodName": "datePicker",
      "description": "点评管家-设置下日期时间选择器",
      "contact": ["hardy.xu", "hardy.xu"]
    },
    {
      "methodName": "cacheSave",// deprecated
      "description": "点评管家-设置本地存储",
      "contact": ["hardy.xu", "hardy.xu"]
    },
    {
      "methodName": "cacheLoad",// deprecated
      "description": "点评管家-设置加载本地存储",
      "contact": ["hardy.xu", "hardy.xu"]
    },
    {
      "methodName": "cacheDelete",// deprecated
      "description": "点评管家-设置删除本地存储",
      "contact": ["hardy.xu", "hardy.xu"]
    },
    {
      "methodName": "cacheClear",// deprecated
      "description": "点评管家-设置删除本地存储",
      "contact": ["hardy.xu", "hardy.xu"]
    },
    {
      "methodName": "setSegments",
      "description": "点评管家-设置tab的title",
      "contact": ["hardy.xu", "hardy.xu"]
    },
    {
      "methodName": "getWiFiInfo",// deprecated
      "description": "点评管家-设置获取wifi信息",
      "contact": ["hardy.xu", "hardy.xu"]
    },
    {
      "methodName": "getReplyLayout",
      "description": "点评管家-设置native回复框",
      "contact": ["hardy.xu", "hardy.xu"]
    },
    {
      "methodName": "stopMusic",
      "description": "点评管家-设置停止播放指定音频",
      "contact": ["hardy.xu", "hardy.xu"]
    },
    {
      "methodName": "queryCalendersEvent",
      "description": "点评管家-设置查询日历事件",
      "contact": ["hardy.xu", "hardy.xu"]
    },
    {
      "methodName": "deleteCalendersEvent",
      "description": "点评管家-设置删除日历事件",
      "contact": ["hardy.xu", "hardy.xu"]
    },
    {
      "methodName": "setCalendersEvent",
      "description": "点评管家-设置添加日历事件",
      "contact": ["hardy.xu", "hardy.xu"]
    },
    {
      "methodName": "getAppInfo",// deprecated
      "description": "点评管家-设置获取app信息",
      "contact": ["hardy.xu", "hardy.xu"]
    },
    {
      "methodName": "showImages",// deprecated
      "description": "点评管家-设置显示图片列表",
      "contact": ["hardy.xu", "hardy.xu"]
    },
    {
      "methodName": "getPrintDevice",// deprecated
      "description": "点评管家-设置获取打印设备",
      "contact": ["hardy.xu", "hardy.xu"]
    },
    {
      "methodName": "uploadImage",
      "description": "点评管家-设置上传图片",
      "contact": ["hardy.xu", "hardy.xu"]
    },
    {
      "methodName": "print",// deprecated
      "description": "点评管家-设置蓝牙打印",
      "contact": ["hardy.xu", "hardy.xu"]
    },
    {
      "methodName": "editPhoto",
      "description": "点评管家-设置在线编辑图片",
      "contact": ["hardy.xu", "hardy.xu"]
    },
    {
      "methodName": "scanQRCode",
      "description": "点评管家-设置二维码扫描",
      "contact": ["hardy.xu", "hardy.xu"]
    },
    {
      "methodName": "selectTab",// deprecated
      "description": "点评管家-设置tab样式的页面的切换",
      "contact": ["hardy.xu", "hardy.xu"]
    },
    {
      "methodName": "cancelUploadImage",// deprecated
      "description": "点评管家-设置取消上传图片",
      "contact": ["hardy.xu", "hardy.xu"]
    },
    {
      "methodName": "setBadge",// deprecated
      "description": "点评管家-设置团购页面底部tab红点信息",
      "contact": ["hardy.xu", "hardy.xu"]
    },
    {
      "methodName": "checkDeal",// deprecated
      "description": "点评管家-设置团单确认的业务处理",
      "contact": ["hardy.xu", "hardy.xu"]
    },
    {
      "methodName": "setTitleRedDot",
      "description": "点评管家-设置团单确认的业务处理",
      "contact": ["hardy.xu", "hardy.xu"]
    },
    {
      "methodName": "getEnv",// deprecated
      "description": "点评管家-设置获取app当前环境",
      "contact": ["hardy.xu", "hardy.xu"]
    },
    {
      "methodName": "ajax",// deprecated
      "description": "点评管家-设置ajax请求处理跨域",
      "contact": ["hardy.xu", "hardy.xu"]
    },
    {
      "methodName": "reuploadImage",// deprecated
      "description": "点评管家-设置重新上传图片",
      "contact": ["hardy.xu", "hardy.xu"]
    },
    {
      "methodName": "getWebViewCapture",
      "description": "点评管家-获得webview的整个页面截图",
      "contact": ["hardy.xu", "hardy.xu"]
    }
  ]
}


//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/compiled/dpzeus/prefix-methods.js
// module id = 545
// module chunks = 0